import { writable } from 'svelte/store';

import type {
	CameraCloudStorageActivePlan,
	CameraCloudStoragePlanTier,
} from 'src/types/CameraCloudStorage';
import { CameraCloudStorageSubscriptionStatus } from 'src/types/CameraCloudStorage';

export type DevPreviewFlow = 'welcome_premium' | 'ccs_welcome' | 'ccs_manage';

export interface DevPreviewState {
	flow: DevPreviewFlow | null;
	tier: CameraCloudStoragePlanTier;
}

export const DEV_PREVIEW_MIN_SLOTS = 3;

export const dev_modal_previews = writable<DevPreviewState>({ flow: null, tier: 3 });

export const startDevPreview = (flow: DevPreviewFlow, tier?: CameraCloudStoragePlanTier): void => {
	dev_modal_previews.update((state) => ({ flow, tier: tier ?? state.tier }));
};

export const clearDevPreview = (): void => {
	dev_modal_previews.update((state) => ({ ...state, flow: null }));
};

export const buildPreviewActivePlan = (
	tier: CameraCloudStoragePlanTier,
): CameraCloudStorageActivePlan => ({
	tier,
	planType: `${tier}_cameras_monthly`,
	status: CameraCloudStorageSubscriptionStatus.Active,
});
